import type { State } from 'redux-store/Store';

export const selectPagination = (state: State) => state.purchases.pagination;
export const selectCurrentPage = (state: State) =>
	state.purchases.pagination.currentPage;
export const selectItemsPerPage = (state: State) =>
	state.purchases.pagination.itemsPerPage;
export const selectTotalItems = (state: State) =>
	state.purchases.pagination.totalItems;
